var origin = window.location.origin;
export var redirectPath = "/auth";
export var redirectUri = "".concat(origin).concat(redirectPath);
export var silentRedirectPath = "/auth-silent";
export var silentRedirectUri = "".concat(origin).concat(silentRedirectPath);

//# sourceMappingURL=routes.js.map